<div class="full-page-bg">
  <div *ngIf="!_as.isUserLoggedIn || _as.isDisplayLogin">
    <app-global-login></app-global-login>
  </div>
  <app-quick-view-popup></app-quick-view-popup>
  <app-save-idea-popup></app-save-idea-popup>
 <!-- Left Sidebar Container -->
<div class="left-sidebar" [class.collapsed]="isCollapsed" *ngIf="_as.isUserLoggedIn && !_as.isOnMobilePlatform">
  
  <!-- Header -->
  <div class="sidebar-header">
    <div class="smart-title">
      <img src="https://res.cloudinary.com/afterbricks/image/upload/v1743484920/icons/star_no3sej.png" alt="Smart Search" />
      <p *ngIf="!isCollapsed">Smart Search <span class="beta-badge">Beta</span></p>
    </div>
    <button class="toggle-btn" (click)="isCollapsed = !isCollapsed">
      <i class="pi" [ngClass]="isCollapsed ? 'pi-angle-double-right' : 'pi-angle-double-left'"></i>
    </button>
  </div>

  <!-- Recent Searches -->
  <div class="recent-section" *ngIf="searchLogs.length">
    <h4 class="recent-title" *ngIf="!isCollapsed">🕘 Recent</h4>
    <ul class="recent-list">
      <li *ngFor="let tl of searchLogs; let i = index" class="recent-item"
          [ngClass]="{ 'active': activeQindex === i || (hoverQindex === i && isOverlayOpen) }">
        
        <div class="recent-query" (click)="selectQuery(tl, i)">
          <i class="pi pi-history icon" *ngIf="isCollapsed"></i>
          <span class="query-text" *ngIf="!isCollapsed">{{ tl.query }}</span>
        </div>

        <div class="query-actions" *ngIf="!isCollapsed">
          <button class="action-btn" (click)="toggleOverlay($event, getlogId, i)">
            <i class="pi pi-ellipsis-v"></i>
          </button>
          <p-overlayPanel #getlogId (onHide)="closeOverlay(getlogId)">
            <div class="popover-menu">
              <div class="popover-item" (click)="shareUrl(tl)">
                <i class="pi pi-share-alt icon"></i><span>Share</span>
              </div>
              <div class="popover-item danger" (click)="deleteQuery(tl)">
                <i class="pi pi-trash icon"></i><span>Delete</span>
              </div>
            </div>
          </p-overlayPanel>
        </div>
      </li>
    </ul>
  </div>
</div>
  <div class="smart-container">
    <!-- Page navigation button show only in mobile -->
    <div class=" smart-banner m-block">
      <div class=" smart-view-img">
        <img src="https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/star_no3sej.png" alt="Smart Search">
        <p>Smart Search</p>
      </div>
      <div class=" smart-menu-btn ">
        <button class="" (click)="smartMenusidebar()" *ngIf="_as.isUserLoggedIn">
        🕘 Recent
        </button>
        <button class="" (click)="onEcosystemsidebar()"
          *ngIf="_ss.query && (related_brands.length || related_dealers.length)">
          Brands
        </button>
      </div>
    </div>
    <div class="smart-heading" *ngIf="!_ss.query">
      <h1> Try "Smart Search"</h1>
    </div>
    <!-- Smart search input -->
    <div class="search-container" #searchInputBox>
      <div class="search-box">
        <input [(ngModel)]="visibleQuery" id="dynamic-placeholder" required pInputText  [placeholder]="searchPlaceholder"
          id="dynamic-placeholder" autocomplete="none|false|no"
          required (keyup.enter)="globleSearch(true);" (focus)="focusSuggetionpup()"
          (focusout)="focusOutSuggetionpup()">
        <div class="button-box">
          <button class="mic" *ngIf="!isListening"> <i class="pi pi-microphone" (click)="startListening()"></i>
          </button>
          <button type="submit" (click)="globleSearch(true)"><i class="pi pi-arrow-circle-up "></i></button>
        </div>
      </div>
    </div>


  <!-- Suggestion Loader -->
<!-- <div *ngIf="isLoadingSuggestions" class="suggestion-loader">
  <p><i class="pi pi-spin pi-spinner"></i> Generating suggestions...</p>
</div> -->

<!-- Product Cards -->
<div *ngIf="products.length">
  <div class="product-card" *ngFor="let p of products">
    <h4>{{ p.name }}</h4>
    <p>{{ p.brand_name }}</p>
    <p>{{ p.description }}</p>
  </div>
</div>

<!-- Follow-up Question -->
<div *ngIf="followupQuestion" class="followup-question">
  <p><strong>Next:</strong> {{ followupQuestion }}</p>
</div>


<!-- LLM Suggestions -->
<!-- <div *ngIf="smartSuggestions?.length && !isLoadingSuggestions" class="llm-suggestion-box">
  <h4 class="suggestion-title">🔮 AI Suggestions</h4>
  <ul>
    <li *ngFor="let suggestion of smartSuggestions" (click)="useSuggestion(suggestion)">
      {{ suggestion }}
    </li>
  </ul>
</div> -->


<!-- No suggestions fallback -->
<!-- <div *ngIf="!smartSuggestions?.length && !isLoadingSuggestions" class="no-suggestions">
  <p>🤖 No AI suggestions found. Try refining your search.</p>
</div> -->

<!-- Search Suggestions Group -->
<div *ngIf="!results.length && !_ss.query && !isSearchLoaded" class="search-suggestion-wrapper">
  <!-- Suggestion Block -->
  <div class="suggestion-card" *ngIf="sampleQueries?.length">
    <h3 class="suggestion-title">✨ Trending search..</h3>
    <div class="chip-container">
      <div class="chip" (click)="selectSampleQuery(query)" *ngFor="let query of sampleQueries" >
        {{ query }}
      </div>
    </div>
  </div>

  <div class="suggestion-card" *ngIf="popularSuggestions?.length">
    <h3 class="suggestion-title">🔥 Popular Searches</h3>
    <div class="chip-container">
      <div class="chip" *ngFor="let query of popularSuggestions" (click)="selectSampleQuery(query)">
        {{ query }}
      </div>
    </div>
  </div>

  <div class="suggestion-card" *ngIf="roomSuggestions?.length">
    <h3 class="suggestion-title">🏠 Search by Room</h3>
    <div class="chip-container">
      <div class="chip" *ngFor="let query of roomSuggestions" (click)="selectSampleQuery(query)">
        {{ query }}
      </div>
    </div>
  </div>
</div>

<!-- Beta Info -->
<!-- <div class="beta-note"
  >
  <p>
    🚧 <strong>Smart View Beta:</strong> We're testing with limited data. Some results may be incomplete or unexpected.
  </p>
</div> -->


    <!-- Voice search listening loader -->
    <div class="listening-box">
      <div class="loader" *ngIf="isListening">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </div>
    <div class="row">
      <!-- after search query before comeing response loader   -->
      <div class="col-12" *ngIf="isProductLoader">
        <div class="loading-message-wrapper">
          <app-typing-loader-text text="Finding smart matches for your {{_ss.query}}"></app-typing-loader-text>
        </div>
        <div class=" product-list-loder  is-loading pl-m-t">
          <div class="product-list   product-loader-list" role="status" aria-label="Loading products..."
            *ngFor="let icon of animatedIcons">
            <div class="product-card animated-loader">
              <div class="product-icon animated-icon">
                <img [src]="icon" alt="Loading icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Show query response data -->
      <div class="col-md-8 col-sm-12" *ngIf="results.length || _ss.query">
        <div class="smart-sec-container" *ngIf="results.length">
          <app-product-typing-banner [query]="_ss.query" [total]="total_products"></app-product-typing-banner>
          <!-- <div> -->
          <p class="nextline-font">   
            <!-- <img class="banner-icon" src="https://res.cloudinary.com/afterbricks/image/upload/v1725704017/icons/circle_ul862h.png" alt=""> -->
            Found  matching {{total_products}} Products</p>
          <!-- </div> -->
        
          <!-- query response products card -->
          <div class="product-list" *ngIf="!isProductLoader">
            <div class="product-card" [@fadeInOut] *ngFor="let product of results;let pi=index">
              <div class="product-image">
                <img [ngSrc]="product?.images[0].image" ngOptimizedImage width="200" height="250" [alt]="product?.name"
                  alt="Product Image">
              </div>
              <div class="product-details">
                <div class="product-brand-name">{{product?.brand?.brand_name}}</div>
                <div class="product-name">{{product.name}}</div>
                <div class="product-price" *ngIf="product?.effective_price">&#8377;{{product?.effective_price |
                  number:'1.0-1'}} <div class="price-unit"
                    *ngIf="getPriceUnit(product?.sub_category?.calculation_type)">
                    /{{getPriceUnit(product?.sub_category?.calculation_type)}}</div>
                  <span *ngIf="product?.discount">{{product?.discount}}% off</span>
                </div>
                <div class="product-description" *ngIf="product?.size">Size({{product.size}})</div>
                <button class="more-deatil-btn" (click)="_qvs.openQuickview(product,pi)">Quick View</button>
              </div>
            </div>
          </div>

          <div class="more-sec"
            *ngIf="total_products > 12 && (total_products - results.length) && !isProductLoader && !isMoreLoader">
            <button class="more-btn" (click)="onMoreProduct()">{{ total_products - results.length}} more items</button>
          </div>
          <div class="more-sec" *ngIf="isMoreLoader">

            <div class="loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-4 col-sm-12" *ngIf="results.length && !isProductLoader && !_as.isOnMobilePlatform">
        <p class="smart-sec-head ssh-mt">
          <!-- <img src="https://res.cloudinary.com/afterbricks/image/upload/v1725704016/icons/triangle_o3pkqi.png"
            alt="Ecosystem"> -->
          Brands
        </p>
        <ul class="related-nav is-loading" *ngIf="isProductLoader">
          <li class="related-nav-link">
            <a class="related-nav-link-a">
              <span></span>
            </a>
          </li>

        </ul>
        <ul class="related-nav" *ngIf="!isProductLoader">
          <li class="related-nav-link" *ngIf="related_brands.length">
            <a class="related-nav-link-a" (click)="showHideBrand()">
              <span>
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1725619774/icons/brand-image_fpa4tf.png"
                  alt="Related brands ">
                Related brands
              </span>
              <i class="pi pi-plus" *ngIf="!isBrandshow"></i>
              <i class="pi pi-minus" *ngIf="isBrandshow"></i>
            </a>
            <div class="related-brands" *ngIf="isBrandshow" [@fadeInOut]>
              <ul class="related-brand-ul " [ngClass]="{'disable-container':isBrandSelecteLoader}">
                <li [ngClass]="{'active-brand-logo':brand.status}" *ngFor="let brand of related_brands;let i = index">
                  <a class="brand-logo" (click)="onBrandFilter(brand,i)">
                    <img [src]="brand?.logo" [alt]="brand?.brand_name">
                    <span> {{brand.product_count}} {{last_query}}</span>
                  </a>
                </li>
              </ul>
              <button class="view-btn" *ngIf="brands.length > 4 && (brands.length - related_brands.length)"
                (click)="moreBrands()">See more <span *ngIf="brands.length - related_brands.length">({{brands.length -
                  related_brands.length}})</span> </button>
              <button class="view-btn" *ngIf="brands.length > 4 && !(brands.length - related_brands.length)"
                (click)="lessBrands()">Less</button>

            </div>
          </li>

        </ul>
        <div class="idea-board" *ngIf="_as.isUserLoggedIn && searchLogService.spaecs?.length">

          <p class="smart-sec-head ssh-mt">
            <img src="https://res.cloudinary.com/afterbricks/image/upload/v1744106374/icons/idea_slomoz.png"
              alt="Idea board">
            Idea board
          </p>
          <div class="spaces">
            <a class="space-card" [ngClass]="{'border-top':si <= 3}" routerLink="../saved-ideas/undefined"
              [queryParams]="{pId:_project.selectedProject?.id,fl:'search',is_department:true,msId:space.main_space_id}"
              *ngFor="let space of searchLogService.spaecs;let si=index">
              <div class="s-icon">
                <img [src]="space?.sub_space_list[0]?.icon" [alt]="space?.name">
              </div>
              <span class="s-name">{{space?.sub_space_list?.length}} {{space?.name}}</span>
              <span class="s-item-count">{{space.avl_main_spaces_product_count}} Items</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- No Results Found Section -->
<div class="smart-sec-container" *ngIf="!results.length && isSearchLoaded && !isProductLoader">
  <div class="data-no-found text-center">
    <svg class="no-results-image" width="150" height="150" viewBox="0 0 24 24" fill="none">
  <path d="M10 2a8 8 0 105.293 14.293l4.707 4.707 1.414-1.414-4.707-4.707A8 8 0 0010 2zm0 2a6 6 0 110 12A6 6 0 0110 4z" fill="#7b1fa2"/>
</svg>
    <h2>Sorry, no results found for <span class="query-highlight">“{{ last_query }}”</span></h2>
    <p class="suggestion-msg">Try searching with different keywords, categories, or check your spelling.</p>
  </div>

  <div class="search-tips-container">
  <h3 class="tips-heading">Search Tips</h3>
  <ul class="search-tips-list">
    <li>🔍 Use more general or broader keywords like <strong>“tiles”</strong>, <strong>“flooring”</strong>, or <strong>“paint”</strong>.</li>
    <li>📝 Try different spellings or common alternatives (e.g. <strong>“wood”</strong> instead of <strong>“timber”</strong>).</li>
    <li>📦 Explore product categories listed below to browse manually.</li>
    <li>🏢 Include space type, like <strong>“kitchen”</strong> or <strong>“office”</strong>, for better results.</li>
  </ul>
</div>

</div>


  <!-- <div class="department-sec" *ngIf="_ds.departments_list?.length">
    <p class="smart-sec-head">Explore popular categories</p>

    <div class="departments">
      <a *ngFor="let depart of _ds.departments_list" 
         title="{{ depart.name }}" 
         (click)="selectSampleQuery(depart.name)">
        <div class="dp-img-box">
          <img ngOptimizedImage 
               width="89" height="89" 
               [src]="depart.icon" 
               [alt]="depart.name" 
               loading="lazy">
        </div>
        <span class="d-item-title">{{ depart.name }}</span>
      </a>
    </div>
  </div> -->

    <!-- <div class="smart-sec-conatiner" *ngIf="!results.length && _ss.query && isSearchLoaded && !isProductLoader">
      <div class="data-no-found text-center">
        <h2>There are no results for "{{last_query}}"</h2>
        <p>Try again using a different spelling or keywords.</p>

      </div>
      <div class="department-sec" *ngIf="!isProductLoader">

        <p class="smart-sec-head">Explore more inspiration from afterbricks</p>
        routerLink="/department/{{depart.slug_name}}"
        <div class="departments" *ngIf="_ds.departments_list">
          <a [title]="depart.name" [title]="depart.name" (click)="selectSampleQuery(depart.name)"
            *ngFor="let depart of _ds.departments_list">
            <div class="dp-img-box">
              <img ngOptimizedImage width="89" height="89" [src]="depart?.icon" alt="category.name" loading="lazy">
            </div>
            <span class="d-item-title">{{depart.name}}</span>
          </a>

        </div>
      </div>
    </div> -->
    <div class="smart-menu">
      <div class="dropdown-container" *ngIf="!results.length && !_ss.query">
        <div class="menu-list parent">
          <div class="position-relative">
            <button class="dw-manu" abindex="0" (mouseenter)="hoveDropdown('material')" (mouseleave)="hoveDropdown('')">
              <span>Material</span>
              <i class="fas fa-caret-down"></i>
              <ul class="dropdown open" *ngIf="activeMenu==='material'">
                <li class="dropdown-item" (mouseenter)="setSubcategorydata(i)"
                  *ngFor="let dep of _ds.departments_list;let i=index">
                  <!-- routerLink="/department/{{dep.slug_name}}" -->
                  <div class="depart-label">
                    <a class="dep-name-strip">
                      <img [src]="dep?.icon" [alt]="dep?.name">
                      <span>{{dep?.name}}</span>
                      <i class="pi pi-angle-right"></i>
                    </a>
                    <ul class="sub-dropdown" *ngIf="sub_categorys.length && activeCati===i">
                      <li class="sub-dropdown-item " *ngFor="let sc of sub_categorys;let sci=index">
                        <a class="sub-depart-label" routerLink="/d/{{dep.slug_name}}/{{sc.slug_name}}">
                          <img [src]="sc?.icon" [alt]="sc?.name">
                          <span>{{sc?.name}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </button>

          </div>
          <button class="dw-manu" (mouseenter)="hoveDropdown('brand')" (mouseleave)="hoveDropdown('')">
            <span>Brand</span>
            <i class="fas fa-caret-down"></i>
            <ul class="dropdown open" *ngIf="activeMenu==='brand'">

              <li class="dropdown-item" (mouseenter)="setSubcategorydata(i)"
                *ngFor="let dep of _ds.departments_list;let i=index">
                <div class="depart-label">
                  <a class="dep-name-strip">
                    <img [src]="dep?.icon" [alt]="dep?.name">
                    <span>{{dep?.name}}</span>
                    <i class="pi pi-angle-right"></i>
                  </a>
                  <ul class="sub-dropdown" *ngIf="sub_categorys.length && activeCati===i">
                    <li class="sub-dropdown-item " *ngFor="let sc of sub_categorys;let sci=index">
                      <a class="sub-depart-label" routerLink="/d/{{dep.slug_name}}/{{sc.slug_name}}">
                        <img [src]="sc?.icon" [alt]="sc?.name">
                        <span>{{sc?.name}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </button>

        </div>
      </div>
    </div>
  </div>

</div>

<!------ Mobile-Smart-Menu-slider-Start------>
<div class="m-block">
  <p-sidebar [(visible)]="smartmenusidebar" position="left" [modal]="true">
    <div class="right-container" *ngIf="_as.isUserLoggedIn && _as.isOnMobilePlatform">
      <div class="moto-hedig">
        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1743484920/icons/star_no3sej.png" alt="">
        <p>Smart Search</p>
      </div>
      <ul class="smart-view-link-ul">
        <li class="smart-view-link-item">
          <div class="smrt-item-box">
            <span class="smrt-item-heading">Recent Search</span>
            <ul class="recent-search-ul" *ngIf="searchLogs.length">

              <li class="recent-search-li" *ngFor="let tl of searchLogs;let tli=index">
                <a class="recent-search-a"
                  [ngClass]="{'active-query':(activeQindex===tli ) || (hoverQindex===tli && isOverlayOpen)}">
                  <span (click)="selectQuery(tl,tli)"> {{tl.query}} </span>
                  <button class="act-log-btn" (click)="toggleOverlay($event, getlogId,tli)">
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                  <p-overlayPanel #getlogId (onHide)="closeOverlay(getlogId)">
                    <div class="popover">
                      <div class="popover-item" (click)="shareUrl(tl)">
                        <i class="pi pi-share-alt icon"></i>
                        <span class="text">Share</span>
                      </div>
                      <div class="popover-item " (click)="deleteQuery(tl)">
                        <i class="pi pi-trash icon color-red"></i>
                        <span class="text color-red">Delete</span>
                      </div>
                    </div>
                  </p-overlayPanel>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </p-sidebar>
</div>
<!------ Mobile-Smart-Menu-slider-End ------>


<!------ Mobile-Ecosystem-slider-Start------>
<div class="m-block">
  <p-sidebar [(visible)]="ecosystemsidebar" position="right" [modal]="true">
    <div class="col-md-4 col-sm-12 pt-4" *ngIf="results.length">
      <p class="smart-sec-head">
        <!-- <img src="https://res.cloudinary.com/afterbricks/image/upload/v1725704016/icons/triangle_o3pkqi.png" alt=""> -->
        Brands
      </p>
      <ul class="related-nav">
        <li class="related-nav-link" *ngIf="related_brands.length">
          <a class="related-nav-link-a" (click)="showHideBrand()">
            <span>
              <img src="https://res.cloudinary.com/afterbricks/image/upload/v1725619774/icons/brand-image_fpa4tf.png"
                alt="">
              Related brands
            </span>
            <i class="pi pi-plus" *ngIf="!isBrandshow"></i>
            <i class="pi pi-minus" *ngIf="isBrandshow"></i>
          </a>
          <div class="related-brands" *ngIf="isBrandshow">
            <ul class="related-brand-ul">
              <li [ngClass]="{'active-brand-logo':brand.status}" *ngFor="let brand of related_brands;let i = index">
                <a class="brand-logo" (click)="onBrandFilter(brand,i)">
                  <img [src]="brand?.logo" [alt]="brand?.brand_name">
                  <span> {{brand.product_count}} {{_ss.query}}</span>
                </a>
              </li>
            </ul>
            <button class="view-btn" *ngIf="brands.length > 4 && (brands.length - related_brands.length)"
              (click)="moreBrands()">See more <span *ngIf="brands.length - related_brands.length">({{brands.length -
                related_brands.length}})</span> </button>
            <button class="view-btn" *ngIf="brands.length > 4 && !(brands.length - related_brands.length)"
              (click)="lessBrands()">Less</button>
          </div>
        </li>

      </ul>

      <div class="idea-board" *ngIf="_as.isUserLoggedIn && searchLogService.spaecs?.length">
        <p class="smart-sec-head ssh-mt">
          <img src="https://res.cloudinary.com/afterbricks/image/upload/v1612439000/BulB_el2hiv.png" alt="Idea board">
          Idea board
        </p>
        <div class="spaces">

          <a class="space-card" [ngClass]="{'border-top':si <= 3}" routerLink="../saved-ideas/undefined"
            [queryParams]="{pId:_project.selectedProject?.id,fl:'search',is_department:true,msId:space.main_space_id}"
            *ngFor="let space of searchLogService.spaecs;let si=index">
            <div class="s-icon">
              <img [src]="space?.sub_space_list[0]?.icon" [alt]="space?.name">
            </div>
            <span class="s-name">{{space?.sub_space_list?.length}} {{space?.name}}</span>
            <span class="s-item-count">{{space.avl_main_spaces_product_count}} Items</span>
          </a>
        </div>
      </div>
    </div>
  </p-sidebar>
</div>
<!------ Mobile-Ecosystem-slider-End ------>
<div class="disclaimer-popup">
  <p-dialog header=" Disclaimer:" [(visible)]="isDisclaimerpopup" styleClass="disclaimer-popup" [modal]="true">
    <p>
      This is a beta version of Smart View and we are currently testing it with limited data. As a result,
      you may encounter unexpected or inappropriate results. We appreciate your understanding and feedback as we work
      to improve the platform.
    </p>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="onDisclaimerok()" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</div>

<div class="footer-note">
  <!-- Smart View is in beta. Some results may be incomplete. <a href="#">Learn more</a>. -->
  <strong>Smart View Beta:</strong> We're testing with limited data. Some results may be incomplete or unexpected.
</div>


<!-- <app-chat-popover></app-chat-popover> -->
